import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const Enterprises = React.lazy(
  () => import('../../modules/provisionify/Enterprises')
);
const Mappings = React.lazy(
  () => import('../../modules/provisionify/Mappings')
);
const WebexSettings = React.lazy(
  () => import('../../modules/provisionify/WebexSettings')
);
const Users = React.lazy(() => import('../../modules/provisionify/Users'));
const Register = React.lazy(
  () => import('../../modules/provisionify/Register')
);

export const provisionifyConfigs = [
  {
    permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
    allowedRoles: ['CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN'],
    path: '/enterprises',
    element: <Enterprises />,
  },
  {
    permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
    allowedRoles: ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN'],
    path: '/mappings/:enterpriseId',
    element: <Mappings />,
  },
  {
    permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
    allowedRoles: ['SUPER_ADMIN', 'CSP_BUSINESS'],
    path: '/webex-settings',
    element: <WebexSettings />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    allowedRoles: ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_ADMIN'],
    path: '/users',
    element: <Users />,
  },
  {
    permittedRole: [],
    allowedRoles: [],
    path: '/register/:key',
    element: <Register />,
  },
];
